"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLang = getLang;
exports.intlMixin = void 0;
exports.setLang = setLang;
exports.t = t;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
var _vue = _interopRequireDefault(require("vue"));
var _zh = _interopRequireDefault(require("./locales/zh.json"));
var _en = _interopRequireDefault(require("./locales/en.json"));
var _ru = _interopRequireDefault(require("./locales/ru.json"));
var _ja = _interopRequireDefault(require("./locales/ja.json"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * ============================================================
 * 国际专区 i18n — 轻量自研方案，不依赖 vue-i18n
 * 原理: 用 Vue 实例做 reactive store，mixin 提供 $t 方法
 * 调用方式: 在组件中 import { intlMixin } 并 mixins: [intlMixin]
 * 不修改 main.js，不影响门户其他页面
 * 创建日期: 2026-09-17
 * ============================================================
 */
var messages = {
  zh: _zh.default,
  en: _en.default,
  ru: _ru.default,
  ja: _ja.default
};
var fallbackLanguages = [{
  value: 'zh',
  label: '中文'
}, {
  value: 'en',
  label: 'English'
}, {
  value: 'ru',
  label: 'Русский'
}];

// reactive store — Vue 实例做简单响应式状态
var store = new _vue.default({
  data: function data() {
    return {
      lang: localStorage.getItem('intl_lang') || 'zh',
      languages: fallbackLanguages
    };
  }
});

/** 翻译函数 — 支持 dot path，如 t('nav.home') */
function t(key) {
  var keys = key.split('.');
  var result = messages[store.lang];
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _k = _step.value;
      if (result && result[_k] !== undefined) {
        result = result[_k];
      } else {
        result = null;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (result === null) {
    result = messages.zh;
    var _iterator2 = _createForOfIteratorHelper(keys),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var k = _step2.value;
        if (result && result[k] !== undefined) {
          result = result[k];
        } else {
          return key;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return result !== undefined ? result : key;
}

/** 切换语言 — 持久化到 localStorage */
function setLang(lang) {
  store.lang = lang;
  localStorage.setItem('intl_lang', lang);
}

/** 使用后端语言字典渲染语言切换；当前值失效时回落到第一个可用语言 */
function setLanguages(options) {
  var languages = (Array.isArray(options) ? options : []).map(function (item) {
    if (typeof item === 'string') return {
      value: item,
      label: item
    };
    return {
      value: item && item.value,
      label: item && item.label || item && item.value
    };
  }).filter(function (item) {
    return item.value && messages[item.value];
  });
  store.languages = languages.length ? languages : fallbackLanguages;
  if (!store.languages.some(function (item) {
    return item.value === store.lang;
  })) {
    setLang(store.languages[0].value);
  }
}

/** 获取当前语言 */
function getLang() {
  return store.lang;
}

/** 国际专区组件 mixin — 提供 $t / $setIntlLang / $intlLang */
var intlMixin = exports.intlMixin = {
  methods: {
    $t: function $t(key) {
      return t(key);
    },
    $setIntlLang: function $setIntlLang(lang) {
      setLang(lang);
    },
    $setIntlLangOptions: function $setIntlLangOptions(options) {
      setLanguages(options);
    },
    $intlLangLabel: function $intlLangLabel(value) {
      var language = store.languages.find(function (item) {
        return item.value === value;
      });
      return language ? language.label : value;
    }
  },
  computed: {
    $intlLang: function $intlLang() {
      return store.lang;
    },
    $intlLangs: function $intlLangs() {
      return store.languages;
    }
  }
};